import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { Subscription } from 'rxjs';
import { Association } from 'src/app/model/assoication';

@Component({
  selector: 'app-training-validation-errors',
  templateUrl: './training-validation-errors.component.html',
  styleUrls: ['./training-validation-errors.component.less']
})
export class TrainingValidationErrorsComponent implements OnInit, OnDestroy {

  @Input()
  public parentGroup: UntypedFormGroup;

  @Input()
  public Asn: Association;

  @Input()
  public Level: 'Student' | 'Professional' | 'Associate' | 'Graduate' = 'Professional';

  public Errors: string[];

  private changeSub: Subscription;

  constructor() { }

  public ngOnInit(): void {
    if (this.parentGroup) {
      this.changeSub = this.parentGroup.valueChanges.subscribe(result => {
        if (this.parentGroup.valid) {
          this.Errors = [];
        } else {
          this.Errors = this.GetValidationErrors();
        }
      });
    }
  }

  public ngOnDestroy(): void {
    if (this.changeSub) {
      this.changeSub.unsubscribe();
      this.changeSub = null;
    }
  }

  private GetValidationErrors(): string[] {
    const errors: string[] = [];

    const License1 = this.parentGroup.get('License1') as UntypedFormGroup;
    const School = this.parentGroup.get('School') as UntypedFormGroup;
    const CourseLength = this.parentGroup.get('CourseLength') as UntypedFormControl;
    const GraduationDate = this.parentGroup.get('GraduationDate') as UntypedFormControl;
    const NameAttended = this.parentGroup.get('NameAttended') as UntypedFormControl;

    if (License1) {
      const State = License1.get('State') as UntypedFormControl;
      const Raw = License1.get('Raw') as UntypedFormControl;
      const Expire = License1.get('Expire') as UntypedFormControl;

      if (State && State.enabled) {
        if (State.invalid && State.errors) {
          if (State.errors['required']) {
            errors.push('<strong>State</strong> is required.');
          }
        }
      }

      if (Raw && Raw.enabled) {
        if (Raw.invalid && Raw.errors) {
          if (Raw.errors['required']) {
            errors.push('<strong>License Number</strong> is required.');
          }
        }
      }

      if (Expire && Expire.enabled) {
        if (Expire.invalid && Expire.errors) {
          if (Expire.errors['required']) {
            errors.push('<strong>Expiration Date</strong> is required.');
          }

          if (Expire.errors['FutureDate']) {
            errors.push('<strong>Expiration Date</strong> must be in the future.');
          }
        }
      }
    }

    if (School) {
      const Name = School.get('Name') as UntypedFormControl;
      const City = School.get('Name') as UntypedFormControl;
      const State = School.get('Name') as UntypedFormControl;

      if (State && State.enabled) {
        if (State.invalid && State.errors) {
          if (State.errors['required']) {
            errors.push('<strong>School State/Province</strong> is required.');
          }
        }
      }

      if (Name && Name.enabled) {
        if (Name.invalid && Name.errors) {
          if (Name.errors['required']) {
            errors.push('<strong>School Name</strong> is required.');
          }
        }
      }

      if (City && City.enabled) {
        if (City.invalid && City.errors) {
          if (City.errors['required']) {
            errors.push('<strong>City</strong> is required.');
          }
        }
      }
    }

    if (CourseLength && CourseLength.enabled) {
      if (CourseLength.invalid && CourseLength.errors) {
        if (CourseLength.errors['required']) {
          errors.push('<strong>Length of ' + (this.Level === 'Professional' ? 'Training' : 'Course') + '</strong> is required.');
        }
      }
    }

    if (GraduationDate && GraduationDate.enabled) {
      if (GraduationDate.invalid && GraduationDate.errors) {
        if (GraduationDate.errors['required']) {
          errors.push('<strong>Graduation Date</strong> is required.');
        }
      }
    }

    if (NameAttended && NameAttended.enabled) {
      if (NameAttended.invalid && NameAttended.errors) {
        if (NameAttended.errors['required']) {
          errors.push('<strong>Name attended school under</strong> is required.');
        }
      }
    }

    return errors;
  }

}
